import React from "react"

// =============================================================================
// Props
// =============================================================================

export type NavigationFooterProps = {
  /** Content pinned to the bottom of the sidebar (nav items, account button, etc.) */
  children?: React.ReactNode
}

// =============================================================================
// Styles
// =============================================================================

const footerStyles = [
  "mt-auto pt-2 px-2 flex flex-col gap-2",
  // Remove horizontal padding from navigation menu when it's inside the footer
  "[&>[data-slot='navigation-menu']]:px-0"
].join(" ")

// =============================================================================
// Component
// =============================================================================

/**
 * Pins its children to the bottom of the sidebar, visually separating them
 * from the scrollable area above.
 *
 * The app layer decides what goes inside — pass any children (nav items,
 * account buttons, etc.).
 */
export function NavigationFooter({ children }: NavigationFooterProps) {
  return (
    <div data-slot="navigation-footer" className={footerStyles}>
      {children}
    </div>
  )
}

NavigationFooter.displayName = "Navigation.Footer"
